import { useParams } from 'react-router-dom'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import Response from 'modules/reviews/components/Response'
import { useReview } from 'modules/reviews/hooks/useReview'

const ResponsesPage = () => {
  const { id } = useParams()
  const { question_group_id } = useParams()
  const { loading, review } = useReview(id)

  return (
    <ResponsivePage.Body showHeader={false} loading={loading} error={!loading && !review}>
      {review && (
        <Response
          form={review}
          questionGroupId={Number(question_group_id)} // eslint-disable-line camelcase
        />
      )}
    </ResponsivePage.Body>
  )
}

export default ResponsesPage
